import {ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {Visibility} from '../../atoms/buttons/buttons-utils';

@Component({
    selector: 'm-dropdown-list',
    templateUrl: './m-dropdown-list.component.html',
    styleUrls: ['./m-dropdown-list.component.scss'],
    standalone: false
})
export class MDropdownListComponent implements OnDestroy {

    private static readonly opened = new Subject<MDropdownListComponent>();

    public actionsOpened = false;

    @Input()
    public modeFilter: boolean;

    @Input()
    public modePriority: boolean;

    @Input()
    public modeCreation: boolean;

    @Input()
    public fullBtnMode: boolean;

    @Input()
    public labelBtnMode: string;

    @Input()
    public positionDropdown: PositionDropdown = 'BOTTOMLEFT';
    public fromPositionDropdown = fromPositionDropdown;

    @Input()
    public buttonVisibility: Visibility = 'LOW';

    @Input()
    public disabled = false;

    @Output()
    toggled: EventEmitter<boolean> = new EventEmitter<boolean>();

    private readonly openedSubscription: Subscription;

    constructor(private elementRef: ElementRef, private changeDetectorRef: ChangeDetectorRef) {
        this.openedSubscription = MDropdownListComponent.opened.subscribe(dropdown => {
            if (dropdown !== this && this.actionsOpened) {
                this.actionsOpened = false;
                this.toggled.emit(this.actionsOpened);
                this.changeDetectorRef.markForCheck();
            }
        });
    }

    public toggleActions(): void {
        if (this.disabled) {
            return;
        }
        this.actionsOpened = !this.actionsOpened;
        this.toggled.emit(this.actionsOpened);
        if (this.actionsOpened) {
            MDropdownListComponent.opened.next(this);
        }
    }

    public ngOnDestroy(): void {
        this.openedSubscription.unsubscribe();
    }

    @HostListener('document:click', ['$event'])
    public onClickOut(event): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.actionsOpened = false;
            this.toggled.emit(this.actionsOpened);
        }
    }
}

export type PositionDropdown =
    'TOPRIGHT'
    | 'TOPLEFT'
    | 'TOPCENTER'
    | 'BOTTOMRIGHT'
    | 'BOTTOMLEFT'
    | 'BOTTOMCENTER'
    | 'LEFT';

export function fromPositionDropdown(positionDropdown: PositionDropdown): string {
    switch (positionDropdown) {
        case 'TOPRIGHT':
            return '_topRight';
        case 'TOPLEFT':
            return '_topLeft';
        case 'TOPCENTER':
            return '_topCenter';
        case 'BOTTOMRIGHT':
            return '_bottomRight';
        case 'BOTTOMLEFT':
            return '_bottomLeft';
        case 'BOTTOMCENTER':
            return '_bottomCenter';
        case 'LEFT':
            return '_left';
    }
}
